import styled from 'styled-components';

interface IProps {
    className?: string;
}

const BaseClearIcon = ({ className }: IProps) => (
    <svg
        className={className}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M16.53 9.182a.75.75 0 0 0-1.06-1.06L12 11.592l-3.47-3.47a.75.75 0 0 0-1.06 1.06l3.47 3.47-3.47 3.471a.75.75 0 1 0 1.06 1.06l3.47-3.47 3.47 3.47a.75.75 0 0 0 1.06-1.06l-3.47-3.47 3.47-3.47Z"
            clipRule="evenodd"
        ></path>
    </svg>
);

export const ClearIcon = styled(BaseClearIcon)`
    width: 24px;
    height: 24px;
`;
